// API 配置
const getBaseURL = () => {
  // 检查是否为正式部署环境（通过域名判断）
  const hostname = window.location.hostname;
  
  // 如果是正式环境域名，使用相对路径
  if (hostname === 'babadeke.com' || hostname.includes('babadeke.com')) {
    return '/api';
  }
  
  // 开发环境使用代理到远程API
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return '/api';  // 使用相对路径，通过package.json中的proxy代理到babadeke.com
  }
  
  // 其他环境直接连接远程API
  return 'https://babadeke.com/api';
};

export const API_CONFIG = {
  baseURL: getBaseURL(),
  BASE_URL: getBaseURL(),
  ENDPOINTS: {
    // 家庭相关
    FAMILY_INFO: (familyId) => `/families/${familyId}/info`,
    FAMILY_POINTS: (familyId) => `/families/${familyId}/points`,
    
    // 任务相关
    TASKS: '/tasks/',
    TASK_CLAIM: (taskId) => `/tasks/${taskId}/claim`,
    TASK_COMPLETE: (taskId) => `/tasks/${taskId}/complete`,
    
    // 奖励任务相关
    REWARD_TASKS: '/reward-tasks/',
    REWARD_TASK_CLAIM: (taskId) => `/reward-tasks/${taskId}/claim`,
    REWARD_TASK_COMPLETE: (taskId) => `/reward-tasks/${taskId}/complete`,
    
    // 积分相关
    USER_POINTS: (userId) => `/users/${userId}/points`,
    EXCHANGE_POINTS: '/exchange-points/',
    
    // 物品相关
    ITEMS: '/items/',
    TASK_ITEMS: (taskId) => `/tasks/${taskId}/items`,
    
    // 奖励相关
    REWARDS: '/rewards/',
    EXCHANGE_REWARD: (rewardId) => `/rewards/${rewardId}/exchange`
  }
};

// 默认用户信息
export const DEFAULT_USER = {
  id: '1',
  name: 'Linc',
  role: 'parent',
  family_id: '6869d0771dfa97eaefc3bbf7',
  timeZone: 'Asia/Shanghai'
};

// 默认家庭信息
export const DEFAULT_FAMILY = {
  name: '快乐家庭',
  members: [
    { id: '1', name: '爸', role: 'parent', avatar: '👨' },
    { id: '2', name: '妈', role: 'parent', avatar: '👩' },
    { id: '3', name: '可', role: 'child', avatar: '👦' },
    { id: '4', name: '玥', role: 'child', avatar: '👧' }
  ]
};

// 兼容性导出
export const API_BASE_URL = getBaseURL();